<div
  class="o-bigmac"
  [ngClass]="getClass()"
  (click)="toggle()"
  id="hamburger">
  <span class="line"></span>
  <span class="line"></span>
  <span class="line"></span>
</div>
